export const LUNA = 'luna';
export const URBANE = 'urbane';
export const LIANO = 'liano';
export const CONTURA = 'contura';
export const OPAL = 'opal';
export const CARE = 'care';
export const WAIPORI = 'waipori';
export const KROME = 'krome';
export const MAKU = 'maku';
export const AIO = 'aio';
export const TUROA = 'turoa';
export const CIVIC = 'civic-collection';
export const URBANE_II_UNIVERSAL = 'caroma-urbane-ii-universal-accessories';
export const CUBE_CLEANFLUSH_URINAL= 'cube-cleanflush-urinal';
export const URBANE_LIANO_HEATED_TOWEL_RAILS= 'urbane-liano-heated-towel-rails';

export const PRODUCT_RANGES = [
    'Opal',
    'Opal II',
    'OpalCare',
    'OPALSUPPORT',
    'Opal II Easy Height',
    'Liano',
    'Liano Care',
    'Liano II',
    'Liano Nexus',
    'Liano Junior',
    'LIANOE',
    'Urbane',
    'Urbane II',
    'Contura',
    'Contura II',
    'Luna',
    'Aio',
    'Krome',
    'Maku',
    'Waipori',
    'Turoa'
  ]; 